module.exports = __webpack_public_path__ + "static/media/zil.86c3735c.svg";